export default {
  "+ Add Horizontal Giude": "+ Добави хоризонтален guide",
  "+ Add Vertical Giude": "+ Добави вертикален giude",
  "2D View": "2D Изглед",
  "3D First Person": "3D First Person",
  "3D View": "3D Изглед",
  "altitude": "Издигнат",
  "Altitude": "Издигнат",
  "Areas": "Пространства",
  "Cancel": "Отказ",
  "Catalog": "Каталог",
  "Chain selected Elements to Group": "Събери избраните елементи в група",
  "Circular": "Кръгъл",
  "color": "цвят",
  "Configure layer": "Конфигурирай слой",
  "Configure project": "Настр.",
  "Confirm": "Потвърди",
  "Copy": "Копирай",
  "Delete group and all Elements": "Изтрий групата и всички елементи",
  "Delete layer": "Изтрий слой",
  "Delete": "Изърий",
  "Elements on layer {0}": "Елементи от слой {0}",
  "Elements": "Елементи",
  "Get Screenshot": "Направи скрийншот",
  "Group [{0}]": "Група [{0}]",
  "Group's Barycenter": "Group's Barycenter",
  "Group's Elements": "Елементи на групата",
  "Groups": "Групи",
  "Guides": "Помощни линии",
  "height": "Височина",
  "Height": "Височина",
  "Holes": "Отвори",
  "Horizontal": "Хоризонтално",
  "Items": "Елементи",
  "Last Selected": "Последно избрано",
  "Layer config": "Конфигурация на слой",
  "Layer": "Слой",
  "Layers": "Слоеве",
  "Length": "Дължина",
  "Lines": "Линии",
  "Load project": "Зареди проект",
  "Mouse X Coordinate": "Координата X на мишката",
  "Mouse Y Coordinate": "Координата Y на мишката",
  "Name": "Име",
  "New Empty Group": "Нова празна група",
  "New Group from selected": "Нова група от избраната",
  "New layer": "Нов слой",
  "New project": "Нов проект",
  "opacity": "прозрачност",
  "Open catalog": "Отвори каталог",
  "order": "подредба",
  "Pan": "Pan",
  "Paste": "Постави",
  "Project config": "Настройки",
  "Properties: [{0}]": "Свойства: [{0}]",
  "Prototype": "Прототип",
  "Reset": "Нулиране",
  "Rotation": "Ротация",
  "Save project": "Запази проект",
  "Save": "Запази",
  "Scene Zoom Level": "Ниво на проближение на сцената",
  "Search Element": "Търси елемент",
  "Snap to Grid": "Snap to Grid",
  "Snap to Guide": "Snap to Guide",
  "Snap to Line": "Snap to Line",
  "Snap to Point": "Snap to Point",
  "Snap to Segment": "Snap to Segment",
  "texture": "текстура",
  "thickness": "дебелина",
  "Toggle Group Visibility": "Превключване на видимостта на групата",
  "Un-chain all Group\'s Elements and remove Group": "Разкачи всички елементи от групата и изтрий групата",
  "Un-chain Element from Group": "Разкачи елемент от група",
  "Undo (CTRL-Z)": "Назад",
  "Unselect": "Unselect",
  "Vertical": "Вертикално",
  "width": "Широчина",
  "Width": "Широчина",
  "Would you want to start a new Project?": "Желаете ли да стартирате нов проектt?",
  "Zoom in": "Увеличаване",
  "Zoom out": "Намаляване",
  "language": "Eзик",
  "Select": "Избери",
  "balcony": "Балкон",
  "Remove": "Изтрий",
  "New": "Нов",
  "Load": "Зареди",
  "View": "Изглед",
  "Picture": "Снимка",
  "MODE_WAITING_DRAWING_LINE": "Режим чертане на стена",
  "MODE_DRAWING_LINE": "Режим чертане на стена",
  "MODE_DRAWING_AREA": "Режим чертане на стая",
  "MODE_DRAWING_ITEM": "Режим чертане на елемент",
  "MODE_DRAWING_HOLE": "Режим чертане на врата/прозорец",
  "Unit": "Мерна единица",
  "Depth": "Дълбочина",
  "radius": "Радиус",
  "depth": "Дълбочина",
  "MODE_WAITING_DRAWING_PIPE": "Режим чертане на тръба",
  "MODE_DRAWING_PIPE": "Режим чертане на тръба",
  'underground': 'Подземна',
  'puncture': 'Пунктове',
  'size': 'Размер',
  'text': 'текст',
  'TextureA': 'Текстура А',
  'TextureB': 'Текстура B',
  'Diameter': 'Диаметър',
  "flip orizzontale": "Завърти хоризонтално",
  "DRAWING_FITTING": "Режим чертане на фитинг",
  "vertical flip": "Завърти вертикално",
  "Thickness": 'Дебелина',
  "Floors": "Етажи",
  "Selected floor": "Текущ етаж",
  "Elevation": "Кота",
  "Floor": "Етаж",
  "Properties": "Свойства",
  "Show floor elevation": "Покажи кота",
  "Search": "Търсене",
  "NameOrDescription": "Име или описание"
};